export default {
  apiKey: 'AIzaSyCupY2RKXQs8i9bChT1kvC-EznO-5cH3AM',
  authDomain: 'orderbytepwa.firebaseapp.com',
  projectId: 'orderbytepwa',
  storageBucket: 'orderbytepwa.appspot.com',
  messagingSenderId: '315390435219',
  appId: '1:315390435219:web:e7102c00d8b5f3ed679266',
  measurementId: 'G-YERN3RT9MP',
};
